<template>
  <div class="page-wrapper">
    <TheHeader />
    <main class="main">
      <div class="page-content">
        <router-view></router-view>
      </div>
    </main>
    <TheFooter />
  </div>
</template>

<script>
import TheHeader from "../components/TheHeader.vue";
import TheFooter from "../components/TheFooter.vue";

export default {
  name: "MainLayout",
  components: {
    TheHeader,
    TheFooter
  },
  computed: {},
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/layouts/MainLayout.vue